export enum EModalSize {
	small = "small",
	large = "large",
	timePicker = "time-picker",
	rangePicker = "range-picker",
	screen = "screen",
	xs = "xs",
	medium = "medium"
}